import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { User } from '../../model/user.model';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../auth/jwt.service';
import { DataSharingService } from '../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  addProductCategory(form) {  
    return this.http.post(this.rootUrl + '/api/Product/AddProductCategory', form);
  }

  getProductCategory() {
    return this.http.get(this.rootUrl + '/api/Product/GetProductCategory');
  }

  addProduct(form) {
    return this.http.post(this.rootUrl + '/api/Product/AddProduct', form);
  }

  getProductList() {
    return this.http.get(this.rootUrl + '/api/Product/GetProductList');
  }

  deleteProductCategory(catid) {

    const category = {
      id: catid
    }
    return this.http.post(this.rootUrl + '/api/Product/DeleteProductCategory', category);
  }

  getCategoryById(catid) {

    const category = {
      id: catid
    }
    return this.http.post(this.rootUrl + '/api/Product/GetCategoryById', category);
  }

  UpdateCategory(form) {
    return this.http.post(this.rootUrl + '/api/Product/UpdateCategory', form);
  }

  getProductById(productid) {

    const category = {
      id: productid
    }
    return this.http.post(this.rootUrl + '/api/Product/GetProductById', category);
  }

  UpdateProduct(form) {
    return this.http.post(this.rootUrl + '/api/Product/UpdateProduct', form);
  }

  deleteProduct(productid) {

    const product = {
      id: productid
    }
    return this.http.post(this.rootUrl + '/api/Product/DeleteProduct', product);
  }

  getProductListForOrder() {
    return this.http.get(this.rootUrl + '/api/Product/GetProductListForOrder');
  }

  getAxProductList() {
    return this.http.get(this.rootUrl + '/api/Product/GetAxProductList');
  }

  filterProduct(keywrd){
    const key = {
      keyword : keywrd
    }
    return this.http.post(this.rootUrl + '/api/Product/FilterProduct', key);
  }

  getLatestProduct() {
    return this.http.get(this.rootUrl + '/api/Product/GetLatestProducts');
  }

  getWeeklySpecials() {
    return this.http.get(this.rootUrl + '/api/Product/GetWeeklySpecials');
  }

}
